/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInstructionVisibilityDto
 */
export interface UpdateInstructionVisibilityDto {
    /**
     * Whether the instruction should be hidden from the patient
     * @type {boolean}
     * @memberof UpdateInstructionVisibilityDto
     */
    isHiddenFromPatient: boolean;
}

/**
 * Check if a given object implements the UpdateInstructionVisibilityDto interface.
 */
export function instanceOfUpdateInstructionVisibilityDto(value: object): value is UpdateInstructionVisibilityDto {
    if (!('isHiddenFromPatient' in value) || value['isHiddenFromPatient'] === undefined) return false;
    return true;
}

export function UpdateInstructionVisibilityDtoFromJSON(json: any): UpdateInstructionVisibilityDto {
    return UpdateInstructionVisibilityDtoFromJSONTyped(json, false);
}

export function UpdateInstructionVisibilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstructionVisibilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isHiddenFromPatient': json['isHiddenFromPatient'],
    };
}

export function UpdateInstructionVisibilityDtoToJSON(json: any): UpdateInstructionVisibilityDto {
    return UpdateInstructionVisibilityDtoToJSONTyped(json, false);
}

export function UpdateInstructionVisibilityDtoToJSONTyped(value?: UpdateInstructionVisibilityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isHiddenFromPatient': value['isHiddenFromPatient'],
    };
}

